var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-wrapper"},[_c('layout-header',{staticStyle:{"height":"80px"}}),_c('layout-main'),_c('layout-sidebar'),_c('layout-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }